





































































import { Component, Vue, Watch, Prop, Provide } from 'vue-property-decorator';
@Component({})
export default class ConfirmDialog extends Vue {
  @Prop() confirmType: string;
  @Prop() show: boolean = false;
  //请假专用
  @Prop() startTime: string;
  @Prop() endTime: string;
  //时间、地点签到确认框专用
  @Prop() time: string;
  @Prop() address: string;
  showDialog: boolean = false;
  currentConfirmType: string = '';
  //时间、地点签到确认框专用
  currentSignTime: string = '';
  currentSignAddress: string = '';
  //请假开始时间、结束时间确认框专用
  leaveStartTime: string = '';
  leaveEndTime: string = '';
  containerStyle: any = {
    backgroundImage: 'url(' + require('@/images/确认框上部分.png') + ')',
    backgroundRepeat: 'round',
    backgroundSize: '100%',
  };

  @Watch('show')
  async onShow(val: boolean) {
    this.showDialog = val;
  }
  @Watch('confirmType')
  async onConfirmType(val: string) {
    if (val) {
      this.currentConfirmType = val;
    }
  }

  //监听时间、地点签到确认框专用
  @Watch('time')
  async onConfirmTime(val: string) {
    if (val) {
      this.currentSignTime = val;
    }
  }
  @Watch('address')
  async onConfirmAddress(val: string) {
    if (val) {
      this.currentSignAddress = val;
    }
  }

  //监听请假开始时间、结束时间确认框专用
  @Watch('startTime')
  async onConfirmStartTime(val: string) {
    if (val) {
      this.leaveStartTime = val;
    }
  }
  @Watch('endTime')
  async onConfirmEndTime(val: string) {
    if (val) {
      this.leaveEndTime = val;
    }
  }

  onConfirm() {
    this.$emit('confirmSubmit', this.currentConfirmType);
  }

  onCancel() {
    this.$emit('confirmCancle');
  }
}
